import { uniqBy } from 'lodash';
import { ref } from 'vue';

import { crossbeamApi } from '@/api';
import useAuth from '@/composables/useAuth';
import { captureException } from '@/errors';

export default function useClearbit(isLoggedIn = true) {
  const searching = ref(false);
  const orgsWithIcons = ref([]);
  const { currentOrg } = useAuth();

  async function getClearbitCompanies(query) {
    if (!query) {
      searching.value = false;
      return [];
    }

    const { data, error } = await crossbeamApi.GET(
      '/v0.1/clearbit-autocomplete',
      {
        params: { query: { query } },
      },
    );
    if (error) {
      return [];
    }
    return Array.isArray(data)
      ? data.map((org) => ({ ...org, label: org.name, value: org.domain }))
      : [];
  }

  async function getCrossbeamCompanies(query) {
    const { data, error } = await crossbeamApi.GET(
      '/v0.1/discoverable-org-search',
      {
        params: {
          query: { query },
        },
      },
    );
    if (error) {
      captureException(error);
      return [];
    }

    return data.items.map((org) => ({ ...org, label: org.name }));
  }

  async function searchIcons(query) {
    searching.value = true;
    const clearbitCompanies = await getClearbitCompanies(query);
    const crossbeamCompanies = isLoggedIn
      ? await getCrossbeamCompanies(query)
      : [];

    orgsWithIcons.value = uniqBy(
      [...crossbeamCompanies, ...clearbitCompanies],
      (company) => company.domain,
    )
      .filter((org) => {
        if (!isLoggedIn) return true;
        return org.domain !== currentOrg.value?.domain;
      })
      .map((org) => ({
        ...org,
        value: org.domain,
        label: `${org.name}`,
      }));
    searching.value = false;
    return orgsWithIcons.value;
  }

  return {
    orgsWithIcons,
    searchIcons,
    searching,
  };
}
